import type { DayHours, NavLink, SiteConfig } from '@/types'

import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'La Douceur',
    description: 'La Douceur یک نانوایی محله‌ای در بروکلین است که هر صبح نان با خمیرترش طبیعی، شیرینی‌های لایه‌ای و کیک می‌پزد. پخت امروز را ببینید، برای تحویل حضوری پیش‌سفارش بدهید یا کیک سفارشی درخواست کنید.',
    url: getOrigin(),
    ogImage: 'https://la-douceur.cdn.modulify.website/social/la-douceur-share.jpg'
}

// The bakery's own details. Every page reads them from here, so changing a value
// here updates the header, footer, visit page, order confirmations and emails.
export const bakery = {
    timezone: 'America/New_York',
    founded: 2019,
    neighborhood: 'بروکلین',
    street: '27 Linden Row',
    locality: 'Brooklyn',
    region: 'NY',
    postalCode: '11205',
    shortAddress: '27 Linden Row, Brooklyn',
    fullAddress: '27 Linden Row, Brooklyn, NY 11205',
    nearby: 'نبش خیابان لیندن رو و خیابان هاثورن',
    phone: '(718) 555-0142',
    phoneHref: 'tel:+17185550142',
    email: 'hello@ladouceurbakery.com',
    instagram: {
        handle: '@ladouceur.bakery',
        url: 'https://www.instagram.com/ladouceur.bakery'
    },
    directionsUrl: `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent('27 Linden Row, Brooklyn, NY 11205')}`
}

// Sunday is day 0. Times are 24-hour, in the bakery's own time zone.
export const OPENING_HOURS: Array<DayHours> = [
    { day: 1, name: 'دوشنبه', short: 'دوشنبه', open: '07:00', close: '18:00' },
    { day: 2, name: 'سه‌شنبه', short: 'سه‌شنبه', open: '07:00', close: '18:00' },
    { day: 3, name: 'چهارشنبه', short: 'چهارشنبه', open: '07:00', close: '18:00' },
    { day: 4, name: 'پنجشنبه', short: 'پنجشنبه', open: '07:00', close: '18:00' },
    { day: 5, name: 'جمعه', short: 'جمعه', open: '07:00', close: '18:00' },
    { day: 6, name: 'شنبه', short: 'شنبه', open: '07:00', close: '17:00' },
    { day: 0, name: 'یکشنبه', short: 'یکشنبه', open: '08:00', close: '15:00' }
]

export const ORDER_RULES = {
    leadMinutes: 120,
    daysAhead: 7,
    slotMinutes: 30,
    slotCapacity: 6,
    firstSlotAfterOpen: 30,
    lastSlotBeforeClose: 30,
    maxQuantityPerItem: 24,
    maxPiecesPerOrder: 60
}

export const CAKE_RULES = {
    leadDays: 3,
    startingPrice: 65,
    startingServings: '۶ تا ۸',
    minServings: 6,
    maxServings: 120,
    replyWithin: 'یک روز کاری'
}

export const CAKE_OCCASIONS = ['تولد', 'عروسی', 'سالگرد', 'جشن نوزاد', 'جشن و مهمانی', 'مناسبت دیگر']

export const CAKE_SPONGES = ['وانیل طبیعی', 'کره‌ی قهوه‌ای', 'شکلات تلخ', 'لیمو و روغن زیتون', 'بادام', 'هویج و ادویه']

export const CAKE_FILLINGS = ['کاستارد وانیلی', 'کارامل نمکی', 'گاناش شکلات تلخ', 'کرد لیمو', 'تمشک و گل‌سرخ', 'کمپوت میوه‌ی فصل']

export const CAKE_FINISHES = ['بدون روکش', 'نیمه‌روکش', 'باترکریم صاف', 'باترکریم بافت‌دار']

export const CAKE_DIETARY = ['بدون گلوتن', 'بدون لبنیات', 'بدون تخم‌مرغ', 'بدون مغزها', 'گیاهی (وگان)']

export const CONTACT_TOPICS = ['سؤال عمومی', 'آلرژی و مواد اولیه', 'عمده‌فروشی یا پذیرایی', 'درباره‌ی یک سفارش', 'موضوع دیگر']

export const NAV_LINKS: Array<NavLink> = [
    { href: '/menu', label: 'منو' },
    { href: '/order', label: 'سفارش' },
    { href: '/custom-cakes', label: 'کیک سفارشی' },
    { href: '/our-story', label: 'داستان ما' },
    { href: '/visit', label: 'بازدید' }
]

// The menu category whose items are made at the counter and never shown in today's bake.
export const DRINKS_CATEGORY = 'coffee-and-drinks'

export const SHELL = 'mx-auto w-full max-w-[90rem] px-5 sm:px-8 lg:px-12'
